/**
 * Convert a numerical value to a readable format
 * 111 -> 111
 * 1111 -> 1.111
 * 111111 -> 111.111
 * 1111111111 -> 1.111.111.111
 * @param {string|Number} value Numerical value to convert.
 * @returns {string} Human readable numerical value.
 */
export default value => {
    const maxSequenceSize = 3;
    const separatorCharacter = '.';

    //Ensure value is string for easy modification
    value = value.toString();

    //Value is already human readable
    if(!value || value.length <= maxSequenceSize){
        return value;
    }

    //Convert our string to an array for easy insertion of separator character
    const arr = [...value];

    //The first complete/part sequence is skipped; this is already considered 'readable'
    const sequenceStartIndex = arr.length % maxSequenceSize || maxSequenceSize;

    //We want to modify our array at every sequence index
    //this needs to happen from right to left to prevent
    //our index from shifting every modification
    for(
        let sequenceIndex = value.length - maxSequenceSize;
        sequenceIndex >= sequenceStartIndex;
        sequenceIndex -= maxSequenceSize
    ) {
        arr.splice(sequenceIndex, 0, separatorCharacter);
    }

    return arr.join('');
}